import { Component, Inject, ChangeDetectionStrategy, inject } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { eOrderStatusType, eSearchJurisdictionState } from '../../enums';
import { SearchJurisdiction } from '../../interfaces/search-jurisdictions/search-jurisdiction';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lib-search-jurisdictions',
  templateUrl: './search-jurisdictions.component.html',
  styleUrl: './search-jurisdictions.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchJurisdictionsComponent {
  private readonly transloco = inject(TranslocoService);
  order: Order;

  _searchStates: eSearchJurisdictionState[] = [
    eSearchJurisdictionState.None,
    eSearchJurisdictionState.Pending,
    eSearchJurisdictionState.Failed,
    eSearchJurisdictionState.Complete,
    eSearchJurisdictionState.InterimNoResults
  ];

  jurisdictions: SearchJurisdiction[] = [];
  columnsToDisplay: string[] = ['jurisdiction', 'hitDirect', 'status'];

  constructor(@Inject(MAT_DIALOG_DATA) public dialogOrder: Order,) {
    this.order = dialogOrder;
  }

  ngOnInit(): void {
    this.jurisdictions = this.order.searchParameters!.searchJurisdictions;
  }

  getStatusFromState(state: eSearchJurisdictionState) {
    switch (state) {
      case eSearchJurisdictionState.None:
        return this.transloco.translate('lienLifetime.pending');
      case eSearchJurisdictionState.InterimNoResults:
        if (this.isOrderClosed()) {
          return this.transloco.translate('searchJurisdictions.complete');
        }
        return this.transloco.translate('searchJurisdictions.waitingOnAutomation');
      case eSearchJurisdictionState.Pending:
        if (this.isOrderClosed()) {
          return this.transloco.translate('searchJurisdictions.error');
        }
        return this.transloco.translate('lienLifetime.pending');
      case eSearchJurisdictionState.Failed:
        return this.transloco.translate('searchJurisdictions.error');
      case eSearchJurisdictionState.Complete:
        return this.transloco.translate('searchJurisdictions.complete');
    }
  }

  isOrderClosed() {
    return (this.order.orderStatusTypeID === eOrderStatusType.complete || this.order.orderStatusTypeID === eOrderStatusType.cancelled);
  }
}
